import { TranslatePipe } from "@ngx-translate/core";

import { ViewportScroller } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";

import { GuidPipe } from "../../../helpers/guidpipe/guidpipe";
import { AuthService } from "../../../services/authservice";
import { MessageService } from "../../../services/messageservice";
import { serviceHealth } from "../../dashboard/service-health-signal/service-health-signal";
import { TrafficSpeedComponent } from "../port-summary/components/traffic-speed/traffic-speed";
import { ServiceTitleBlock } from "../service-title-block/service-title-block";

export interface InterconnectSummaryService {
  subscriptionId: string;
  description: string;
  customerDescription?: string | null;
  organisation?: string | null;
  customerId?: string | null;
  tags?: string[] | null;
  product: { type: string; tag: string };
}

@Component({
  selector: "interconnect-summary",
  templateUrl: "interconnect-summary.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [GuidPipe, ServiceTitleBlock, TrafficSpeedComponent, TranslatePipe],
})
export class InterconnectSummary {
  private auth = inject(AuthService);
  private msgsrv = inject(MessageService);
  private viewportScroller = inject(ViewportScroller);

  protected service = input.required<InterconnectSummaryService>();

  protected subscriptionInstanceId = input<string>();
  protected forceTrafficBottom = input(false);
  protected showTraffic = input(false);

  protected isAccessible = computed(() => this.auth.viewingCustomer().customerId === this.service().customerId);
  protected health = serviceHealth(this.service);

  protected subscriptionId = computed(() => this.service().subscriptionId);
  protected tags = computed(() => this.service().tags ?? []);

  protected organisationName = computed(() => this.service().organisation ?? "-");
  protected title = computed(() => this.service().customerDescription ?? this.service().description);

  protected navigateToChart() {
    this.viewportScroller.scrollToAnchor("chart");
    this.msgsrv.setChartFilter({ connection: this.service(), vlanranges: [] });
  }
}
